<template>
  <div class="mt-[124px] text-success flex items-center gap-1 text-xs">
    <span class="material-symbols-rounded text-base">check_circle</span>
    האימות התבצע בהצלחה! הנכם מועברים להתחברות למערכת
  </div>
</template>

<script>
export default {
  name: "email-verification-successful",
  async mounted() {
    setTimeout(() => {
      const firstVisit = localStorage.getItem("firstVisit");
      if (firstVisit === null || firstVisit === "true") {
        localStorage.setItem("firstVisit", "true");
        this.$store.dispatch("onboarding/toggleShow");
      }
      this.$router.push('/login');
    }, 2000);
  }
}
</script>

<style>

</style>
